import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Heading = React.forwardRef(function Heading(
  { as: Component = 'h1', size = 1, className, ...rest },
  ref
) {
  return (
    <Component ref={ref} className={classnames('heading', `size-${size}`, className)} {...rest} />
  )
})

Heading.displayName = 'Heading'
Heading.propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4]),
  as: PropTypes.elementType,
}

export default Heading
